module.exports = require("uuid");


//////////////////
// WEBPACK FOOTER
// external "uuid"
// module id = 21
// module chunks = 0